import Layout from "../../components/Layout/Layout";

const EMAIL = "lunamalies@earthboundmartian.com";

const Contact = () => {
  return (
    <Layout>
      <section className="max-w-3xl mx-auto px-6 py-16 w-full">
        <p className="text-sun font-semibold uppercase tracking-wide text-sm">
          Lunamalies
        </p>
        <h1 className="text-5xl font-bold text-alt-blk mt-3">Contact</h1>
        <p className="text-xl text-alt-blk/80 mt-6 leading-relaxed">
          For catalog corrections, source suggestions, or questions about the
          archive, write to{" "}
          <a
            href={`mailto:${EMAIL}`}
            className="text-turquoise hover:text-mars break-all"
          >
            {EMAIL}
          </a>
          .
        </p>
        <p className="leading-relaxed mt-6">
          v1 is read-only. We are not taking new TLP submissions yet. When that
          opens, it will have a moderation path so the catalog stays cited and
          neutral.
        </p>
        <a
          href={`mailto:${EMAIL}`}
          className="inline-block mt-10 bg-mars hover:bg-sunset text-white px-8 py-4 rounded-2xl font-semibold"
        >
          Email Lunamalies
        </a>
      </section>
    </Layout>
  );
};

export default Contact;
